import type { App } from 'vue';
import VueTippy from 'vue-tippy';
import 'tippy.js/dist/tippy.css';

export default (app: App) => {
  app.use(VueTippy);
};
